/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classes from './Backdrop.module.css';

const Backdrop = ({ onBackdropClick }) => (
  <div className={classes.backdrop} onClick={onBackdropClick} />
);

export default Backdrop;

Backdrop.propTypes = {
  onBackdropClick: PropTypes.func,
};

Backdrop.defaultProps = {
  onBackdropClick: () => { },
};
